import React from "react";
import { observer } from "mobx-react-lite";

import { Trash } from "../svg/svgImageList";
import useThemeService from "../../services/theme-service/ThemeService";
import { translationService } from "../../services/translation/TranslationService";
import { FileExtended } from "../../services/upload/FileUploadTracker";
import Button from "../button/Button";

interface UploadTableType {
  files?: Array<FileExtended>;
  onRemoveFile: Function;
}

export default observer(function UploadTable(props: UploadTableType) {
  const { files = [], onRemoveFile } = { ...props };

  const { themeClass } = useThemeService();

  function removeFile(name: string) {
    const fileToRemove = files.find((file) => file.name === name);
    if (fileToRemove) {
      onRemoveFile(fileToRemove.name);
    }
  }

  return (
    <table className={themeClass(["upload-dropped-files-table"])}>
      <thead>
        <tr>
          <th>{translationService.translate("general.name")}</th>
          <th>{translationService.translate("general.remove")}</th>
        </tr>
      </thead>
      <tbody>
        {files.map((file: FileExtended) => (
          <tr key={`${file.name}-${file.path}`}>
            <td>{file.name}</td>
            <td>
              <Button
                onClick={() => removeFile(file.name)}
                icon={{ svg: Trash, className: themeClass(["icon-trash"]) }}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
});
